import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilters,
  removeFilters,

  hubs = [],
  selectedHubIds = [],
  setSelectedHubIds,
  showHubFilter = false,
}) {
  const [hubSearch, setHubSearch] = useState("");
  const [tempSelectedHubIds, setTempSelectedHubIds] = useState([]);

  useEffect(() => {
    if (show) {
      setTempSelectedHubIds(selectedHubIds || []);
      setHubSearch("");
    }
  }, [show]);

  const getHubName = (hub) =>
    hub.name || hub.hubname || hub.hubName || "Unnamed Hub";

  const filteredHubs = hubs
    .filter((hub) => hub.status !== "Inactive")
    .filter((hub) =>
      getHubName(hub).toLowerCase().includes(hubSearch.toLowerCase()),
    )
    .sort((a, b) => getHubName(a).localeCompare(getHubName(b)));

  const handleHubChange = (hubId, checked) => {
    setTempSelectedHubIds((previousIds) =>
      checked
        ? previousIds.includes(hubId)
          ? previousIds
          : [...previousIds, hubId]
        : previousIds.filter((id) => id !== hubId),
    );
  };

  const handleSelectAll = () => {
    setTempSelectedHubIds((previousIds) => [
      ...new Set([...previousIds, ...filteredHubs.map((hub) => hub._id)]),
    ]);
  };

  const handleClearHubs = () => {
    setTempSelectedHubIds([]);
  };

  const handleApply = () => {
    setSelectedHubIds?.(tempSelectedHubIds);
    applyFilters?.();
    onHide?.();
  };

  const handleRemoveFilters = () => {
    setTempSelectedHubIds([]);
    setHubSearch("");
    removeFilters?.();
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {showHubFilter ? (
          <Form.Group>
            <Form.Label className="fw-semibold">Hubs</Form.Label>

            <Form.Control
              type="text"
              placeholder="Search hub..."
              value={hubSearch}
              onChange={(e) => setHubSearch(e.target.value)}
              className="mb-2"
            />

            <div className="d-flex justify-content-between mb-2">
              <Button
                type="button"
                variant="outline-secondary"
                size="sm"
                onClick={handleSelectAll}
                disabled={!filteredHubs.length}
              >
                Select All
              </Button>

              <Button
                type="button"
                variant="outline-danger"
                size="sm"
                onClick={handleClearHubs}
                disabled={!tempSelectedHubIds.length}
              >
                Clear Hubs
              </Button>
            </div>

            <div
              className="border rounded p-2"
              style={{ maxHeight: "220px", overflowY: "auto" }}
            >
              {filteredHubs.length > 0 ? (
                filteredHubs.map((hub) => (
                  <Form.Check
                    key={hub._id}
                    type="checkbox"
                    id={`challan-hub-${hub._id}`}
                    label={getHubName(hub)}
                    checked={tempSelectedHubIds.includes(hub._id)}
                    onChange={(e) => handleHubChange(hub._id, e.target.checked)}
                    className="mb-1"
                  />
                ))
              ) : (
                <p className="text-muted mb-0">No hubs found.</p>
              )}
            </div>

            <small className="text-muted d-block mt-2">
              {tempSelectedHubIds.length === 0
                ? "No hubs selected — all accessible hubs will be shown."
                : `${tempSelectedHubIds.length} hub(s) selected.`}
            </small>
          </Form.Group>
        ) : (
          <p className="mb-0">
            No additional filters available for Vehicle Challan.
          </p>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleRemoveFilters}>
          Remove Filters
        </Button>

        <Button variant="outline-secondary" onClick={onHide}>
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={handleApply}
          disabled={showHubFilter && !setSelectedHubIds}
        >
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
